import React from 'react';
import { ClipLoader } from 'react-spinners';

const SavePanel = ({ remarks, onRemarksChange, showRenewedCheckbox, makeRenewedActive, onToggleRenewedActive, errorMessage, saving, onSave, onCancel }) => (
  <div className="border-box2 p-3 mt-3">
    {errorMessage && (
      <div className="alert alert-danger" role="alert">
        {errorMessage}
      </div>
    )}
    <label className="form-label d-flex justify-content-between">
      <span>
        Remarks<span className="text-danger">*</span>
      </span>
      <span className="text-muted small">{(remarks || '').length}/500</span>
    </label>
    <textarea
      className="form-control"
      rows={3}
      maxLength={500}
      value={remarks}
      onChange={(e) => onRemarksChange(e.target.value)}
    />

    {showRenewedCheckbox && (
      <div className="d-flex align-items-center gap-2 mt-3">
        <input type="checkbox" id="makeRenewedActive" checked={makeRenewedActive} onChange={(e) => onToggleRenewedActive(e.target.checked)} />
        <label htmlFor="makeRenewedActive" className="form-label mb-0">
          Make existing renewed lease active
        </label>
      </div>
    )}

    <div className="d-flex justify-content-end gap-2 mt-3">
      <button type="button" className="mainbtnRed" disabled={saving} onClick={onCancel}>
        Cancel
      </button>
      <button type="button" className="mainbtn" disabled={saving} onClick={onSave}>
        {saving ? <ClipLoader color="#ffffff" size={18} /> : 'Save'}
      </button>
    </div>
  </div>
);

export default SavePanel;
